var _mask, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1540_2139",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29785 15.9966C12.7161 15.9966 16.2979 12.4149 16.2979 7.99658C16.2979 3.5783 12.7161 -0.00341797 8.29785 -0.00341797C3.87957 -0.00341797 0.297852 3.5783 0.297852 7.99658C0.297852 12.4149 3.87957 15.9966 8.29785 15.9966ZM8.29746 10.3966C9.62294 10.3966 10.6975 9.32207 10.6975 7.99659C10.6975 6.6711 9.62294 5.59659 8.29746 5.59659C6.97198 5.59659 5.89746 6.6711 5.89746 7.99659C5.89746 9.32207 6.97198 10.3966 8.29746 10.3966Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29785 15.9966C12.7161 15.9966 16.2979 12.4149 16.2979 7.99658C16.2979 3.5783 12.7161 -0.00341797 8.29785 -0.00341797C3.87957 -0.00341797 0.297852 3.5783 0.297852 7.99658C0.297852 12.4149 3.87957 15.9966 8.29785 15.9966ZM8.29746 10.3966C9.62294 10.3966 10.6975 9.32207 10.6975 7.99659C10.6975 6.6711 9.62294 5.59659 8.29746 5.59659C6.97198 5.59659 5.89746 6.6711 5.89746 7.99659C5.89746 9.32207 6.97198 10.3966 8.29746 10.3966Z",
    fill: "url(#paint0_linear_1540_2139)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2979 7.99658C15.2979 11.8626 12.1638 14.9966 8.29785 14.9966V16.9966C13.2684 16.9966 17.2979 12.9671 17.2979 7.99658H15.2979ZM8.29785 0.996582C12.1638 0.996582 15.2979 4.13059 15.2979 7.99658H17.2979C17.2979 3.02602 13.2684 -1.00342 8.29785 -1.00342V0.996582ZM1.29785 7.99658C1.29785 4.13059 4.43186 0.996582 8.29785 0.996582V-1.00342C3.32729 -1.00342 -0.702148 3.02602 -0.702148 7.99658H1.29785ZM8.29785 14.9966C4.43186 14.9966 1.29785 11.8626 1.29785 7.99658H-0.702148C-0.702148 12.9671 3.32729 16.9966 8.29785 16.9966V14.9966ZM9.69746 7.99659C9.69746 8.76979 9.07066 9.39659 8.29746 9.39659V11.3966C10.1752 11.3966 11.6975 9.87436 11.6975 7.99659H9.69746ZM8.29746 6.59659C9.07066 6.59659 9.69746 7.22339 9.69746 7.99659H11.6975C11.6975 6.11882 10.1752 4.59659 8.29746 4.59659V6.59659ZM6.89746 7.99659C6.89746 7.22339 7.52426 6.59659 8.29746 6.59659V4.59659C6.41969 4.59659 4.89746 6.11882 4.89746 7.99659H6.89746ZM8.29746 9.39659C7.52426 9.39659 6.89746 8.76979 6.89746 7.99659H4.89746C4.89746 9.87436 6.41969 11.3966 8.29746 11.3966V9.39659Z",
    fill: "#FA8A24",
    fillOpacity: 0.8,
    mask: "url(#path-1-inside-1_1540_2139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1540_2139",
    x1: 16.2979,
    y1: 0.16927,
    x2: 0.643227,
    y2: 0.16927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8A24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioChecked);
export default __webpack_public_path__ + "static/media/radio-checked.368fb17ccb5489e131dd399ae8cffe56.svg";
export { ForwardRef as ReactComponent };